import { writable } from "svelte/store";

const models = writable([]);

export const hasValueByType = (models, type) => {
  for (let i = 0; i < models.length; i++) {
    if (models[i][type]) return true;
  }
  return false;
}

export default models;